export default __webpack_public_path__ + "b4117f7af0adb0d0f909e2e92fa3c088.png";